import { render, staticRenderFns } from "./waitDeal.vue?vue&type=template&id=35ddae3e&"
import script from "./waitDeal.vue?vue&type=script&lang=js&"
export * from "./waitDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports